import { NMAWindow } from "./nma-window";

declare const window : NMAWindow;

export function notifyNmaOfCartUpdate() {
    const iosBridge = window?.webkit?.messageHandlers?.MiniCartJsBridge;
    const androidBridge = window?.MiniCartJsBridge;
    try {
        // iOS case
        if (iosBridge) {
            iosBridge.postMessage("");
        }
        // Android case
        else if (androidBridge) {
            androidBridge.refreshCart();
        } 
        // Bridges not present, log for observability
        else {
            console.error("notifyNmaOfCartUpdate() called but bridge not present. Android bridge:",androidBridge,"iOS bridge:", iosBridge);
        } 
    } catch (e) {
        console.error("notifyNmaOfCartUpdate() called but an error occurred.", e, "Android bridge:",androidBridge,"iOS bridge:", iosBridge);
    }

}